<mat-spinner diameter="100" strokeWidth="2"></mat-spinner>
